import { connect } from "react-redux";
import Item from "../components/Item";

const mapStateToProps = ({ Dimension, Misc }) => ({
    returnReasonList: Dimension.ReturnReason.returnReasonList,

    //Misc
    language: Misc.Settings.language
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Item);
